import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SEARCH,
    loadComponent: () =>
      import('./search-results.component').then(
        (m) => m.SearchResultsComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SEARCH,
    loadComponent: () =>
      import('./search-results.component').then(
        (m) => m.SearchResultsComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchResultsModule {}
